<template>
    <v-navigation-drawer
        location="right"
        :class="`${mobilMode?'courses-progress-h-mobile':'courses-progress-h-full'}  left-direction`"
        v-model="value"
        :absolute="breakPointMdDown"
        :permanent="!breakPointMdDown"
        disable-resize-watcher
        width="280"
    >
        <v-list-item class="pb-3">
            <v-list-item-content>
                <v-list-item-title class="courses-progress-side-title text-end">
                    {{ course.title }}
                </v-list-item-title>
            
            </v-list-item-content>
        </v-list-item>

        <v-list
            nav
        >
        
            <v-list-item v-for="(section, indexS) in course.sections" :key="indexS">
                <v-list-item-content>
                    <v-list-item-title class="courses-progress-side-subtitle text-end">
                        {{ section.title }}
                    </v-list-item-title>
                    <div class="courses-progress-section-list-body" v-for="(lesson, indexL) in section.lessons" :key="indexL">
                        <div class="ml-4 courses-progress-lesson-content mb-1" @click="selectLesson(lesson, indexS, indexL)">
                        
                            <p :class="`mx-1 pb-0 mb-0 courses-progress-textwrap text-end clic ${!lesson.has_content?'grey--text':''} ${lesson.selected?'courses-progress-selected-text':''} `" >{{ lesson.title }}</p>
                            <v-icon class="ml-0" color="green" v-if="lesson.completed">
                                mdi-check-circle-outline
                            </v-icon>
                            <v-icon class="ml-0" color="" v-else>
                                mdi-circle-outline
                            </v-icon>
                            

                        </div>
                        <v-divider class=""></v-divider>
                    </div>



                
                
                </v-list-item-content>
                
            </v-list-item>
            
        </v-list>





    </v-navigation-drawer>
</template>

<script>
/* eslint-disable */
export default {
    props: ['course','mobilMode', 'appMode', 'valueInput'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                if(value == null)
                    this.$emit('valueChange', false)
                else
                    this.$emit('valueChange', value)
            }
        },
        breakPointMdDown () {
            return this.$vuetify.breakpoint.mdAndDown;
        },
    },
    data(){
        return {
        }
    },
    watch: {
        
    },
    mounted(){
        
    },
    methods: {
        selectLesson(lesson, indexSection, indexLession){
            console.log(lesson,"ok")
            this.$emit('selectLessonAction', {lesson, indexSection, indexLession})
        },
        
    }
}
</script>

<style lang="scss">
    .hr-base{
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: 0;
        background-color: black;
    }

    .courses-progress{
        &-h-full{
            max-height: calc(100vh - 148px) !important;
        }
        &-h-mobile{
            max-height: calc(100vh - 350px);
            min-height: calc(100vh - 150px);
        }

        &-main-title-row{
            border-bottom: 1px solid black;
        }

        &-content-body{
            // width: calc(100% - 257px);
            
            overflow-x: hidden;
            overflow-y: auto;

            display: flex;
            flex-direction: column;
            padding-bottom: 15px;

            width: calc(100%);
            padding: 0.625rem 3.125rem 0.625rem 3.125rem;
            @media (max-width: #{map-get($grid-breakpoints, 'sm')}) {
                padding: 20px;
            }
        }

        &-side-title{
            font-weight: 600;
            font-size: 1rem;
            text-wrap-mode: wrap;
        }

        &-lesson-content{
            display: flex;
            align-items: baseline;
            justify-content: flex-end;
            p{
                padding-bottom: 0 !important;
            }
        }
        &-side-subtitle{
            font-weight: 600;
            font-size: 0.95rem;
            text-wrap-mode: wrap;
        }

        &-main-container{
            display: flex;
            justify-content: space-between;
        }

        &-title{
            font-weight: 800;
            font-size: 0.95rem;
        }


        &-item{
            display: flex;
        }

        &-list{
            padding-left: 30px !important;
            &-item li::marker {
                    font-size: 2rem;
                    color: #18585b;
                    // margin: 10px;
                }
        }

        &-selected-text{
            font-weight: 700;
            color: var(--v-primary-base);
        }

        &-textwrap{
            word-break: break-word;
        }
    }
</style>